import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HiChevronRight } from 'react-icons/hi';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { VALUES } from '../utils/constants';

const AboutSection = () => {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation({ threshold: 0.3 });

  return (
    <section style={{
      backgroundColor: '#FAF7F2',
      padding: 'clamp(4rem, 8vw, 7rem) 1.5rem',
      borderTop: '1px solid var(--color-border)',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <motion.div
          ref={contentRef}
          initial={{ opacity: 0, y: 20 }}
          animate={contentVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          style={{ maxWidth: '720px' }}
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: '#1A1A1A',
            marginBottom: '1.5rem',
            fontFamily: '"DM Sans", sans-serif',
          }}>
            Built by technologists who understand Indian business
          </h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <p style={{ fontSize: '1rem', lineHeight: 1.7, color: '#333333', fontFamily: '"DM Sans", sans-serif' }}>
              Rishant Technologies was founded with one clear purpose: to make the kind of AI automation that large enterprises enjoy, accessible and affordable for every Indian small business.
            </p>
            <p style={{ fontSize: '1rem', lineHeight: 1.7, color: '#333333', fontFamily: '"DM Sans", sans-serif' }}>
              Our team brings 15+ years of software engineering experience, combined with deep knowledge of how Indian SMBs actually operate. We don't sell generic tools. We build systems that fit your specific workflow.
            </p>
          </div>

          {/* Values */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', marginTop: '2rem' }}>
            {VALUES.map((value) => (
              <div
                key={value.id}
                style={{
                  padding: '0.625rem 1.25rem',
                  border: '1px solid var(--color-border)',
                  borderRadius: '999px',
                  fontFamily: '"DM Sans", sans-serif',
                }}
              >
                <span style={{ fontSize: '0.875rem', fontWeight: 600, color: '#1A1A1A' }}>
                  {value.name}
                </span>
                <span style={{ fontSize: '0.8rem', color: '#666666', marginLeft: '0.5rem' }}>
                  — {value.description}
                </span>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div style={{ marginTop: '2.5rem' }}>
            <Link
              to="/about"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '0.95rem',
                fontWeight: 600,
                color: '#1A1A1A',
                textDecoration: 'none',
                fontFamily: '"DM Sans", sans-serif',
              }}
            >
              More about us <HiChevronRight size={18} />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
